import { render, staticRenderFns } from "./Brain.vue?vue&type=template&id=701e9095&scoped=true&"
import script from "./Brain.vue?vue&type=script&lang=js&"
export * from "./Brain.vue?vue&type=script&lang=js&"
import style0 from "./Brain.vue?vue&type=style&index=0&id=701e9095&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "701e9095",
  null
  
)

export default component.exports